import React from 'react';

interface ChartMiniProps {
  data: number[];
  width?: number;
  height?: number;
  className?: string;
}

const ChartMini: React.FC<ChartMiniProps> = ({ 
  data, 
  width = 200, 
  height = 60, 
  className = '' 
}) => {
  const maxValue = Math.max(...data);
  const minValue = Math.min(...data);
  const range = maxValue - minValue;
  
  const points = data.map((value, index) => {
    const x = (index / (data.length - 1)) * width;
    const y = height - ((value - minValue) / range) * height;
    return `${x},${y}`;
  }).join(' ');

  return (
    <div className={`${className}`}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
        <polyline
          fill="none"
          stroke="rgb(var(--color-chart))"
          strokeWidth="2"
          points={points}
        />
        {data.map((value, index) => {
          const x = (index / (data.length - 1)) * width;
          const y = height - ((value - minValue) / range) * height;
          return (
            <circle
              key={index}
              cx={x}
              cy={y}
              r="3"
              fill="rgb(var(--color-chart))"
            />
          );
        })}
      </svg>
    </div>
  );
};

export default ChartMini;
